{
    "Accessibility menu": "የተደራሽነት ምናሌ",
    "Close": "ዝጋ",
    "Content adjustments": "የይዘት ማስተካከያዎች",
    "Navigation adjustments": "የአሰሳ ማስተካከያዎች",
    "Text Align": "የጽሑፍ አሰላለፍ",
    "Align Left": "ግራ አሰልፍ",
    "Align Center": "መሃል አሰልፍ",
    "Align Right": "ወደ ቀኝ አሰልፍ",
    "Adjust Font Size": "የፊደል መጠን አስተካክል",
    "Highlight Title": "ርዕስ አጉልተው አሳይ",
    "Highlight Links": "አገናኞችን አጉልተው አሳይ",
    "Readable Font": "ለማንበብ ቀላል ፊደል",
    "Colour adjustments": "የቀለም ማስተካከያዎች",
    "Dark Contrast": "ጨለማ ንጽጽር",
    "Light Contrast": "ብርሃናዊ ንጽጽር",
    "High Contrast": "ከፍተኛ ንጽጽር",
    "High Saturation": "ከፍተኛ ሙሌት",
    "Low Saturation": "ዝቅተኛ ሙሌት",
    "Monochrome": "ነጠላ ቀለም",
    "Tools": "መሳሪያዎች",
    "Reading Guide": "የንባብ መመሪያ",
    "Big Cursor": "ትልቅ ጠቋሚ",
    "Increase Font Size": "የፊደል መጠን ጨምር",
    "Decrease Font Size": "የፊደል መጠን አሳንስ",
    "Letter Spacing": "የፊደል ክፍተት",
    "Line Height": "የመስመር ቁመት",
    "Font Weight": "የፊደል ውፍረት",
    "Dyslexia Font": "የዲስሌክሲያ ፊደል",
    "Language": "ቋንቋ",
    "Accessibility widget": "የተደራሽነት ምናሌን ክፈት",
    "Accessibility Profiles": "የተደራሽነት መገለጫዎች",
    "Cognitive Disability": "የግንዛቤ ጉድለት",
    "Seizure Safe": "ከመንቀጥቀጥ ደህና",
    "Accessibility statement": "የተደራሽነት መግለጫ",
    "ADHD": "ADHD",
    "Low Vision": "ዝቅተኛ እይታ",
    "Pause Animations": "አኒሜሽኖችን አቁም",
    "Animation paused": "እነማ ቆሟል",
    "Reset all settings": "ቅንብሮችን ዳግም አስጀምር",
    "Shortcut:": "አቋራጭ:",
    "Epilepsy Safe Mode": "ከሚጥል በሽታ ደህና ሁነታ",
    "Mute sounds": "ድምፆችን አጥፋ",
    "Page read": "ገጽ ማንበብ",
    "Page read controls": "የገጽ ንባብ መቆጣጠሪያዎች",
    "Pause": "ለአፍታ አቁም",
    "Resume": "ቀጥል",
    "Stop": "አቁም",
    "Settings": "ቅንብሮች",
    "Speed": "ፍጥነት",
    "Voice": "ድምፅ",
    "Close accessibility menu": "የተደራሽነት ምናሌን ዝጋ",
    "Back to accessibility menu": "ወደ ተደራሽነት ምናሌ ተመለስ",
    "Search languages": "ቋንቋዎችን ፈልግ",
    "Selected language": "የተመረጠ ቋንቋ",
    "View accessibility statement (opens in new window)": "የተደራሽነት መግለጫን ይመልከቱ (በአዲስ መስኮት ይከፈታል)",
    "Visit CookieYes website (opens in new window)": "የCookieYes ድረ-ገጽን ይጎብኙ (በአዲስ መስኮት ይከፈታል)",
    "Reset all accessibility settings to default": "ሁሉንም የተደራሽነት ቅንብሮች ወደ ነባሪ ዳግም አስጀምር"
}
